module.exports = __webpack_public_path__ + "media/images/product/a1-356569fce48b167982951f52b864807a.png";